import { MenuGroup, MenuItem } from '@/components/shared/Menu/Menu.types';
import { BeamIcon, DocumentsIcon } from '@onbeam/icons/business';
import { FC } from 'react';

type ButtonData = {
  value: string;
  label: string;
  icon: FC<React.SVGProps<SVGSVGElement>>;
  items: (MenuGroup | MenuItem)[];
}[];

export const exchangeMenuItems: MenuGroup[] = [
  {
    title: 'Buy on exchange',
    items: [
      {
        label: 'Binance',
        href: 'https://www.binance.com/en/price/onbeam',
        isExternal: true,
      },
      {
        label: 'Bybit',
        href: 'https://www.bybit.com/en/trade/spot/BEAM/USDT',
        isExternal: true,
      },
      {
        label: 'Upbit',
        href: 'https://upbit.com/exchange?code=CRIX.UPBIT.USDT-BEAM',
        isExternal: true,
      },
      {
        label: 'Kraken',
        href: 'https://pro.kraken.com/app/trade/BEAM-USD?c/2223866/1766749/10583',
        isExternal: true,
      },
    ],
  },
  {
    title: 'Trade on',
    items: [
      {
        label: 'Beam Swap',
        href: 'https://swap.onbeam.com',
        isExternal: true,
      },
      {
        label: 'Uniswap',
        href: 'https://app.uniswap.org/explore/tokens/ethereum/0x62d0a8458ed7719fdaf978fe5929c6d342b0bfce',
        isExternal: true,
      },
    ],
  },
];

export const forDevelopersMenuItems: MenuItem[] = [
  {
    label: 'Beam grants',
    href: 'https://grants.onbeam.com',
    isExternal: true,
  },
  {
    label: 'Developer docs',
    href: 'https://docs.onbeam.com/',
    isExternal: true,
  },
];

export const getStartedButtonData: ButtonData = [
  {
    value: 'buyBeam',
    label: 'Buy Beam',
    icon: BeamIcon,
    items: exchangeMenuItems,
  },
  {
    value: 'forDevelopers',
    icon: DocumentsIcon,
    label: 'For developers',
    items: forDevelopersMenuItems,
  },
];
